import { ToggleButton, ToggleButtonGroup, useTheme } from "@mui/material";
import { ArrowDownIcon, ArrowUpIcon, type LucideIcon } from "lucide-react";
import type { ObjPathProxy } from "ts-object-path";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type DirectionOption = {
	desc: boolean;
	labelKey: ObjPathProxy<unknown, string>;
	Icon: LucideIcon;
};

const DIRECTION_OPTIONS: DirectionOption[] = [
	{
		desc: false,
		labelKey: Resources.Portfolio.List.Redesign.Filter.ascending,
		Icon: ArrowUpIcon,
	},
	{
		desc: true,
		labelKey: Resources.Portfolio.List.Redesign.Filter.descending,
		Icon: ArrowDownIcon,
	},
];

type Props = {
	value: boolean;
	onChange: (sortDesc: boolean) => void;
};

export const SortDirectionToggle = ({ value, onChange }: Props) => {
	const { t } = useResource();
	const theme = useTheme();

	return (
		<ToggleButtonGroup
			segmented
			exclusive
			value={value}
			onChange={(_, next: boolean | null) => {
				if (next !== null) {
					onChange(next);
				}
			}}
		>
			{DIRECTION_OPTIONS.map(({ desc, labelKey, Icon }) => (
				<ToggleButton segmented key={String(desc)} value={desc} disableRipple>
					<Icon size={theme.iconSize.xs} />
					{t(labelKey)}
				</ToggleButton>
			))}
		</ToggleButtonGroup>
	);
};
